export const ATTACHMENTS = 'ATTACHMENTS';
export const LABELS = 'LABELS';

export const DEFAULT_VITALS = [LABELS, ATTACHMENTS];

export default [LABELS, ATTACHMENTS];
